export const SYSTEM_STATUSES: { value: string; label: string }[] = [
  { value: "operational", label: "Operational" },
  { value: "under-development", label: "Under Development" },
  { value: "disposition", label: "Disposition" },
  { value: "other", label: "Other" },
];

export const IMPLEMENTATION_STATUSES: { value: string; label: string }[] = [
  { value: "implemented", label: "Implemented" },
  { value: "partial", label: "Partially Implemented" },
  { value: "planned", label: "Planned" },
  { value: "alternative", label: "Alternative" },
  { value: "not-implemented", label: "Not Implemented" },
  { value: "not applicable", label: "Not Applicable" },
];

export const CONTROL_ORIGINATIONS: { value: string; label: string }[] = [
  { value: "system-specific", label: "System Specific" },
  { value: "inherited", label: "Inherited" },
  { value: "customer-configured", label: "Customer Configured" },
  { value: "customer", label: "Customer" },
  { value: "customer-responsibility", label: "Customer Responsibility" },
  { value: "hybrid", label: "Hybrid" },
  { value: "shared", label: "Shared" },
  { value: "provider-specific", label: "Provider Specific" },
  { value: "provider", label: "Provider" },
];
